import { render, staticRenderFns } from "./album-item.vue?vue&type=template&id=030a657d&"
import script from "./album-item.vue?vue&type=script&lang=js&"
export * from "./album-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports